import React, { useState, useEffect, useRef } from "react";
import EditAtdLayout from "../../Components/EditAtdLayout";
import "./edit-atd.css";
import { FaUsers, FaEdit, FaCheckCircle, FaWpforms } from "react-icons/fa";
import { Row, Col, Button, Form, Pagination, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { IoEye } from "react-icons/io5";
import axios from "axios";
import { MdAccessTime } from "react-icons/md";
import { FaDownload, FaPrint } from "react-icons/fa";
import { TbReplaceFilled } from "react-icons/tb";
import { MdDelete } from "react-icons/md";

export default function MonthlyAtd() {
  const { userId } = useParams();
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [employee, setEmployee] = useState({ name: "" });
  const [selectedDocId, setSelectedDocId] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState("");
  const [docCategory, setDocCategory] = useState("");
  const [earlyCloseDocs, setEarlyCloseDocs] = useState({});
  const [overtimeDocs, setOvertimeDocs] = useState({});
  const [lateDocs, setLateDocs] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [showEarlyLeaveApprovalModal, setShowEarlyLeaveApprovalModal] = useState(false);
  const [showLateApprovalModal, setShowLateApprovalModal] = useState(false);
  const [showOvertimeApprovalModal, setShowOvertimeApprovalModal] = useState(false);
  const [approvalData, setApprovalData] = useState({});
  const [hrSignature, setHrSignature] = useState("");
  const [adminSignature, setAdminSignature] = useState("");
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [applySingleDeduction, setApplySingleDeduction] = useState(false);
  const fileInputRef = useRef(null);
  const printRef = useRef(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);

  const role = localStorage.getItem("role");

  useEffect(() => {
    if (!userId) {
      console.error("No userId provided in URL");
      return;
    }

    const fetchEmployeeDetails = async () => {
      try {
        const response = await fetch(
          `https://backend.ems.hiradentallab.com/api/user/user/${userId}`
        );
        if (!response.ok) throw new Error("Failed to fetch employee details");
        const data = await response.json();

        if (data.success && data.employee) {
          setEmployee({
            name: data.employee.EmployeeName,
            department: data.employee.department || "Not specified",
            userId: data.employee.EmployeeId,
          });
        }
      } catch (error) {
        console.error("Error fetching employee details:", error);
      }
    };

    const fetchAttendanceData = async () => {
      try {
        const response = await fetch(
          `https://backend.ems.hiradentallab.com/api/attendance/attendance/monthly/${userId}?month=${selectedMonth}`
        );
        if (!response.ok) throw new Error("Failed to fetch attendance data");
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          const processedData = data.data.map((item) => ({
            ...item,
            lateReason: item.lateReason ?? "Not provided",
            earlyCloseReason: item.earlyCloseReason ?? "Not provided",
            overtimeReason: item.overtimeReason ?? "Not provided",
            lateSingleDeduction: item.lateSingleDeduction ?? false,
            earlyCloseSingleDeduction: item.earlyCloseSingleDeduction ?? false,
            lateHrSignature: item.lateHrSignature ?? null,
            lateAdminSignature: item.lateAdminSignature ?? null,
            earlyCloseHrSignature: item.earlyCloseHrSignature ?? null,
            earlyCloseAdminSignature: item.earlyCloseAdminSignature ?? null,
            overtimeHrSignature: item.overtimeHrSignature ?? null,
            overtimeAdminSignature: item.overtimeAdminSignature ?? null,
          }));
          setAttendanceData(processedData);
          setFilteredData(processedData);

          const earlyCloseDocs = {};
          const overtimeDocs = {};
          const lateDocs = {};
          data.data.forEach((item) => {
            earlyCloseDocs[item._id] = item.earlyCloseDocs ? item.earlyCloseDocs : null;
            overtimeDocs[item._id] = item.overtimeDocs ? item.overtimeDocs : null;
            lateDocs[item._id] = item.lateDocs ? item.lateDocs : null;
          });
          setEarlyCloseDocs(earlyCloseDocs);
          setOvertimeDocs(overtimeDocs);
          setLateDocs(lateDocs);
        }
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      }
    };

    fetchEmployeeDetails();
    fetchAttendanceData();
  }, [userId, selectedMonth]);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    const lowercasedSearchTerm = searchValue.toLowerCase();
    const filtered = attendanceData.filter(
      (item) =>
        item.userName?.toLowerCase().includes(lowercasedSearchTerm) ||
        moment(item.date).format("YYYY-MM-DD").toLowerCase().includes(lowercasedSearchTerm)
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredData.map((item, index) => ({
        SR: (currentPage - 1) * rowsPerPage + index + 1,
        Date: moment(item.date).format("YYYY-MM-DD"),
        CheckIn: moment(item.checkIn).format("HH:mm:ss"),
        CheckOut: item.checkOut ? moment(item.checkOut).format("HH:mm:ss") : "N/A",
        WorkedHours: item.workedHours || "N/A",
        LateMinutes: item.lateMinutes || "0",
        EarlyCloseMinutes: item.earlyCloseMinutes || "0",
        Overtime: item.extraMinutes || "0",
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
    XLSX.writeFile(workbook, "Attendance.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text(`${employee.name}'s Attendance Report`, 20, 10);
    doc.autoTable({
      head: [["SR", "Date", "CheckIn", "CheckOut", "Worked Hours", "Late Minutes", "Early Close Minutes", "Overtime"]],
      body: filteredData.map((item, index) => [
        (currentPage - 1) * rowsPerPage + index + 1,
        moment(item.date).format("YYYY-MM-DD"),
        moment(item.checkIn).format("HH:mm:ss"),
        item.checkOut ? moment(item.checkOut).format("HH:mm:ss") : "N/A",
        item.workedHours || "N/A",
        item.lateMinutes || "0",
        item.earlyCloseMinutes || "0",
        item.extraMinutes || "0",
      ]),
    });
    doc.save(`${employee.name}_Attendance.pdf`);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(filteredData.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);
    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handleShowModal = (item) => {
    setModalData(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalData({});
  };

  const handleViewDocument = (docUrl, item, category) => {
    if (!docUrl || !item || !item._id) {
      console.error("Invalid document or item:", { docUrl, item });
      alert("Something went wrong. Document or attendance data missing.");
      return;
    }

    let formattedUrl = docUrl.startsWith("http")
      ? docUrl
      : `http://localhost:5544${
          docUrl.startsWith("/uploads") ? docUrl : `/uploads/${docUrl}`
        }`;

    setSelectedDocUrl(formattedUrl);
    setSelectedDocId(item._id);
    setDocCategory(category);
    setShowViewModal(true);
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(selectedDocUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const filename = selectedDocUrl.split("/").pop() || "document";
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed. Please try again.");
    }
  };

  const handleFileReplace = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedDocId || !docCategory) {
      alert("No file selected, attendance ID missing, or document category not specified.");
      return;
    }

    const formData = new FormData();
    formData.append("document", file);
    formData.append("uploadCategory", docCategory);

    try {
      const response = await fetch(
        `https://backend.ems.hiradentallab.com/api/attendance/update-document/${selectedDocId}`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();

      if (response.ok) {
        alert("Document replaced successfully!");
        setShowViewModal(false);
        const response = await fetch(
          `https://backend.ems.hiradentallab.com/api/attendance/attendance/monthly/${userId}?month=${selectedMonth}`
        );
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          const processedData = data.data.map((item) => ({
            ...item,
            lateReason: item.lateReason ?? "Not provided",
            earlyCloseReason: item.earlyCloseReason ?? "Not provided",
            overtimeReason: item.overtimeReason ?? "Not provided",
            lateSingleDeduction: item.lateSingleDeduction ?? false,
            earlyCloseSingleDeduction: item.earlyCloseSingleDeduction ?? false,
            lateHrSignature: item.lateHrSignature ?? null,
            lateAdminSignature: item.lateAdminSignature ?? null,
            earlyCloseHrSignature: item.earlyCloseHrSignature ?? null,
            earlyCloseAdminSignature: item.earlyCloseAdminSignature ?? null,
            overtimeHrSignature: item.overtimeHrSignature ?? null,
            overtimeAdminSignature: item.overtimeAdminSignature ?? null,
          }));
          setAttendanceData(processedData);
          setFilteredData(processedData);
          const earlyCloseDocs = {};
          const overtimeDocs = {};
          const lateDocs = {};
          data.data.forEach((item) => {
            earlyCloseDocs[item._id] = item.earlyCloseDocs ? item.earlyCloseDocs : null;
            overtimeDocs[item._id] = item.overtimeDocs ? item.overtimeDocs : null;
            lateDocs[item._id] = item.lateDocs ? item.lateDocs : null;
          });
          setEarlyCloseDocs(earlyCloseDocs);
          setOvertimeDocs(overtimeDocs);
          setLateDocs(lateDocs);
        }
      } else {
        alert(data.message || "Failed to replace document");
      }
    } catch (error) {
      console.error("Error replacing file:", error);
      alert("Error replacing file.");
    }
  };

  const resetApprovalData = () => {
    setApprovalData({});
    setHrSignature("");
    setAdminSignature("");
    setIsViewOnly(false);
    setApplySingleDeduction(false);
  };

  const handleOpenEarlyLeaveApprovalForm = (item, viewOnly = false) => {
    console.log("Opening Early Leave Approval Form for item:", item);
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.earlyCloseHrSignature;
    const adminHasApproved = !!item.earlyCloseAdminSignature;

    const canEditHRSignature = currentRole === "HR" && !hrHasApproved;
    const canEditAdminSignature = currentRole === "admin";

    setApprovalData({
      userName: item.userName || employee.name,
      userId: item.userId || employee.userId,
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || employee.department,
      type: "Early Leave",
      minutes: item.earlyCloseMinutes || 0,
      reason: item.earlyCloseReason || "Not provided",
      attendanceId: item._id,
      singleDeduction: item.earlyCloseSingleDeduction || false,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature,
      canEditAdminSignature,
      currentRole,
    });
    setHrSignature(item.earlyCloseHrSignature || "");
    setAdminSignature(item.earlyCloseAdminSignature || "");
    setApplySingleDeduction(item.earlyCloseSingleDeduction || false);
    setIsViewOnly(viewOnly || (!canEditHRSignature && !canEditAdminSignature && currentRole !== "admin"));
    setShowEarlyLeaveApprovalModal(true);
    console.log("Early Leave Modal State Set:", { showEarlyLeaveApprovalModal: true, approvalData });
  };

  const handleOpenLateApprovalForm = (item, viewOnly = false) => {
    console.log("Opening Late Approval Form for item:", item);
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.lateHrSignature;
    const adminHasApproved = !!item.lateAdminSignature;

    const canEditHRSignature = currentRole === "HR" && !hrHasApproved;
    const canEditAdminSignature = currentRole === "admin";

    setApprovalData({
      userName: item.userName || employee.name,
      userId: item.userId || employee.userId,
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || employee.department,
      type: "Late Arrival",
      minutes: item.lateMinutes || 0,
      reason: item.lateReason || "Not provided",
      attendanceId: item._id,
      singleDeduction: item.lateSingleDeduction || false,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature,
      canEditAdminSignature,
      currentRole,
    });
    setHrSignature(item.lateHrSignature || "");
    setAdminSignature(item.lateAdminSignature || "");
    setApplySingleDeduction(item.lateSingleDeduction || false);
    setIsViewOnly(viewOnly || (!canEditHRSignature && !canEditAdminSignature && currentRole !== "admin"));
    setShowLateApprovalModal(true);
    console.log("Late Approval Modal State Set:", { showLateApprovalModal: true, approvalData });
  };

  const handleOpenOvertimeApprovalForm = (item, viewOnly = false) => {
    console.log("Opening Overtime Approval Form for item:", item);
    resetApprovalData();
    const currentRole = localStorage.getItem("role");
    const hrHasApproved = !!item.overtimeHrSignature;
    const adminHasApproved = !!item.overtimeAdminSignature;

    const canEditHRSignature = currentRole === "HR" && !hrHasApproved;
    const canEditAdminSignature = currentRole === "admin" && !adminHasApproved;

    setApprovalData({
      userName: item.userName || employee.name,
      userId: item.userId || employee.userId,
      date: new Date(item.checkIn).toLocaleDateString(),
      department: item.department || employee.department,
      type: "Overtime",
      minutes: item.extraMinutes || 0,
      reason: item.overtimeReason || "Not provided",
      attendanceId: item._id,
      hrHasApproved,
      adminHasApproved,
      canEditHRSignature,
      canEditAdminSignature,
      currentRole,
    });
    setHrSignature(item.overtimeHrSignature || "");
    setAdminSignature(item.overtimeAdminSignature || "");
    setIsViewOnly(viewOnly || (!canEditHRSignature && !canEditAdminSignature));
    setShowOvertimeApprovalModal(true);
    console.log("Overtime Modal State Set:", { showOvertimeApprovalModal: true, approvalData });
  };

  const handleApprove = async (type) => {
    if (!role || (role !== "HR" && role !== "admin")) {
      alert("You do not have permission to approve this request. Please log in as HR or Admin.");
      return;
    }
    if (role === "HR" && !hrSignature) {
      alert("Please provide an HR signature before approving.");
      return;
    }
    if (role === "admin" && !approvalData.adminHasApproved && !adminSignature) {
      alert("Please provide an Admin signature before approving.");
      return;
    }

    try {
      const normalizedType = type === "earlyClose" ? "earlyClose" : type.toLowerCase();
      const updateData = {
        type: normalizedType,
        approve: role === "admin" && !approvalData.adminHasApproved ? true : undefined,
        semiApproved: role === "HR" ? true : undefined,
        deduct: normalizedType !== "overtime" && role === "admin" ? !applySingleDeduction : undefined,
        singleDeduction: normalizedType !== "overtime" && role === "admin" ? applySingleDeduction : undefined,
        hrSignature: role === "HR" ? hrSignature : undefined,
        adminSignature: role === "admin" && !approvalData.adminHasApproved ? adminSignature : undefined,
      };

      console.log("Sending approval request:", updateData);

      const response = await axios.put(
        `https://backend.ems.hiradentallab.com/api/attendance/${approvalData.attendanceId}/deduct`,
        updateData,
        {
          headers: {
            'x-user-role': role,
          },
        }
      );

      if (response.status === 200) {
        alert(`Attendance ${normalizedType} ${role === "admin" && approvalData.adminHasApproved ? "deduction updated" : role === "admin" ? "approved" : "semi-approved"} successfully!`);
        const signatureFields = {
          late: {
            hrSignatureField: "lateHrSignature",
            adminSignatureField: "lateAdminSignature",
            minutesField: "lateMinutes",
            singleDeductionField: "lateSingleDeduction",
            deductedField: "lateDeducted",
          },
          earlyClose: {
            hrSignatureField: "earlyCloseHrSignature",
            adminSignatureField: "earlyCloseAdminSignature",
            minutesField: "earlyCloseMinutes",
            singleDeductionField: "earlyCloseSingleDeduction",
            deductedField: "earlyCloseDeducted",
          },
          overtime: {
            hrSignatureField: "overtimeHrSignature",
            adminSignatureField: "overtimeAdminSignature",
            minutesField: "extraMinutes",
          },
        };
        const updateState = (prev) =>
          prev.map((item) =>
            item._id === approvalData.attendanceId
              ? {
                  ...item,
                  [`${normalizedType}Approved`]: role === "admin" && !approvalData.adminHasApproved ? true : item[`${normalizedType}Approved`],
                  [`${normalizedType}SemiApproved`]: role === "HR" ? true : item[`${normalizedType}SemiApproved`],
                  ...(normalizedType !== "overtime" && role === "admin"
                    ? {
                        [signatureFields[normalizedType].deductedField]: !applySingleDeduction,
                        [signatureFields[normalizedType].singleDeductionField]: applySingleDeduction,
                        [signatureFields[normalizedType].minutesField]: response.data.data[signatureFields[normalizedType].minutesField],
                      }
                    : {}),
                  [signatureFields[normalizedType].hrSignatureField]: role === "HR" ? hrSignature : item[signatureFields[normalizedType].hrSignatureField],
                  [signatureFields[normalizedType].adminSignatureField]: role === "admin" && !approvalData.adminHasApproved ? adminSignature : item[signatureFields[normalizedType].adminSignatureField],
                }
              : item
          );
        setAttendanceData(updateState);
        setFilteredData(updateState);
        if (type === "late") setShowLateApprovalModal(false);
        if (type === "earlyClose") setShowEarlyLeaveApprovalModal(false);
        if (type === "overtime") setShowOvertimeApprovalModal(false);
        resetApprovalData();
      } else {
        alert("Failed to approve attendance record.");
      }
    } catch (error) {
      console.error("Error approving attendance:", error.response?.data || error);
      alert(
        "Error approving attendance record: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  const handlePrint = () => {
    const printContent = printRef.current.innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  const handleDeleteRecord = async () => {
    if (!recordToDelete) return;

    try {
      const response = await axios.post(
        "https://backend.ems.hiradentallab.com/api/attendance/attendance/delete",
        {
          attendanceId: recordToDelete._id,
          userId: userId,
          date: recordToDelete.date,
        }
      );

      if (response.data.success) {
        setAttendanceData((prev) =>
          prev.filter((item) => item._id !== recordToDelete._id)
        );
        setFilteredData((prev) =>
          prev.filter((item) => item._id !== recordToDelete._id)
        );

        setEarlyCloseDocs((prev) => {
          const newDocs = { ...prev };
          delete newDocs[recordToDelete._id];
          return newDocs;
        });

        setOvertimeDocs((prev) => {
          const newDocs = { ...prev };
          delete newDocs[recordToDelete._id];
          return newDocs;
        });

        setLateDocs((prev) => {
          const newDocs = { ...prev };
          delete newDocs[recordToDelete._id];
          return newDocs;
        });

        alert("Attendance record deleted successfully!");
      } else {
        alert("Failed to delete attendance record: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting attendance record:", error);
      alert(
        "Error deleting attendance record: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setShowDeleteModal(false);
      setRecordToDelete(null);
    }
  };

  const handleDeleteClick = (item) => {
    setRecordToDelete(item);
    setShowDeleteModal(true);
  };

  return (
    <EditAtdLayout>
      <h1 className="edit-atd-title">
        <FaUsers /> {employee.name ? `${employee.name}'s` : "Employee"} Attendance
      </h1>
      <hr />
      <div className="edit-atd-content">
        <div className="table-actions">
          <Row className="w-100">
            <Col xs={12} md={4} className="d-flex align-items-center">
              <input
                type="month"
                className="form-control"
                value={selectedMonth}
                onChange={handleMonthChange}
              />
            </Col>
            <Col xs={12} md={4} className="d-flex align-items-center">
              <Button
                variant="secondary"
                className="export-button"
                onClick={exportToExcel}
              >
                Export to Excel
              </Button>
              <Button
                variant="secondary"
                className="export-button"
                onClick={exportToPDF}
              >
                Export to PDF
              </Button>
            </Col>
            <Col xs={12} md={4} className="d-flex justify-content-end">
              <Form>
                <Form.Control
                  type="search"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                  aria-label="Search"
                  className="search-bar"
                />
              </Form>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-style">
            <thead className="edit-atd-table-header">
              <tr>
                <th>SR</th>
                <th>Date</th>
                <th>CheckIn</th>
                <th>CheckOut</th>
                <th>Worked Hours</th>
                <th>Late Absent Minutes</th>
                <th>Early Absent Minutes</th>
                <th>Overtime</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData
                .slice(
                  (currentPage - 1) * rowsPerPage,
                  currentPage * rowsPerPage
                )
                .map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>
                      {new Date(item.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </td>
                    <td>
                      {new Date(item.checkIn).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </td>
                    <td>
                      {item.checkOut
                        ? new Date(item.checkOut).toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : "N/A"}
                    </td>
                    <td>{item.workedHours || "N/A"}</td>
                    <td>
                      {item.lateMinutes || "0"}{" "}
                      {lateDocs[item._id] && (
                        <Button
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontWeight: "500",
                            padding: "4px 8px",
                            backgroundColor: "#17a2b8",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginLeft: "9px",
                            border: "none",
                          }}
                          onClick={() =>
                            handleViewDocument(lateDocs[item._id], item, "late")
                          }
                        >
                          <IoEye />
                        </Button>
                      )}
                      {item.lateMinutes > 0 && (
                        <Button
                          variant={item.lateApproved ? "success" : "danger"}
                          size="sm"
                          style={{ marginLeft: "5px" }}
                          onClick={() => handleOpenLateApprovalForm(item)}
                        >
                          {item.lateApproved ? <FaCheckCircle /> : <FaWpforms />}
                        </Button>
                      )}
                    </td>
                    <td>
                      {item.earlyCloseMinutes || "0"}{" "}
                      {earlyCloseDocs[item._id] && (
                        <Button
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontWeight: "500",
                            padding: "4px 8px",
                            backgroundColor: "#17a2b8",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginLeft: "9px",
                            border: "none",
                          }}
                          onClick={() =>
                            handleViewDocument(earlyCloseDocs[item._id], item, "earlyClose")
                          }
                        >
                          <IoEye />
                        </Button>
                      )}
                      {item.earlyCloseMinutes > 0 && (
                        <Button
                          variant={item.earlyCloseApproved ? "success" : "danger"}
                          size="sm"
                          style={{ marginLeft: "5px" }}
                          onClick={() => handleOpenEarlyLeaveApprovalForm(item)}
                        >
                          {item.earlyCloseApproved ? <FaCheckCircle /> : <FaWpforms />}
                        </Button>
                      )}
                    </td>
                    <td>
                      {item.extraMinutes || "0"}{" "}
                      {overtimeDocs[item._id] && (
                        <Button
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontWeight: "500",
                            padding: "4px 8px",
                            backgroundColor: "#17a2b8",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginLeft: "9px",
                            border: "none",
                          }}
                          onClick={() =>
                            handleViewDocument(overtimeDocs[item._id], item, "overtime")
                          }
                        >
                          <IoEye />
                        </Button>
                      )}
                      {item.extraMinutes > 0 && (
                        <Button
                          variant={item.overtimeApproved ? "success" : "danger"}
                          size="sm"
                          style={{ marginLeft: "5px" }}
                          onClick={() => handleOpenOvertimeApprovalForm(item)}
                        >
                          {item.overtimeApproved ? <FaCheckCircle /> : <FaWpforms />}
                        </Button>
                      )}
                    </td>
                    <td>
                      <div>
                        <Link to={`/edit-atd/${item._id}`}>
                          <Button
                            variant="warning"
                            size="sm"
                            style={{ marginRight: "5px" }}
                          >
                            <FaEdit />
                          </Button>
                        </Link>
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() => handleShowModal(item)}
                          style={{ marginRight: "5px" }}
                        >
                          <MdAccessTime />
                        </Button>
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() => handleDeleteClick(item)}
                        >
                          <MdDelete />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot className="edit-atd-table-footer">
              <tr>
                <td>Total</td>
                <td>{filteredData.length}</td>
                <td colSpan="7"></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {pageRange().map((page) => (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={
              currentPage === Math.ceil(filteredData.length / rowsPerPage)
            }
          />
        </Pagination>
      </div>
      {/* Attendance Details Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="lg"
        dialogClassName="fancy-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Attendance Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>UserId:</strong> {modalData.userId || employee.userId}
          </p>
          <p>
            <strong>Name:</strong> {modalData.userName || employee.name}
          </p>
          <p>
            <strong>CheckIn:</strong>{" "}
            {modalData.checkIn
              ? new Date(modalData.checkIn).toLocaleString()
              : "N/A"}
          </p>
          <p>
            <strong>CheckOut:</strong>{" "}
            {modalData.checkOut
              ? new Date(modalData.checkOut).toLocaleString()
              : "N/A"}
          </p>
          <p>
            <strong>Worked Hours:</strong> {modalData.workedHours || "N/A"}
          </p>
          <p>
            <strong>Late Reason:</strong> {modalData.lateReason || "Not provided"}
          </p>
          <p>
            <strong>Early Close Reason:</strong> {modalData.earlyCloseReason || "Not provided"}
          </p>
          <p>
            <strong>Overtime Reason:</strong> {modalData.overtimeReason || "Not provided"}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* View Document Modal */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span>View Document</span>
            <div style={{ display: "flex", gap: "10px" }}>
              {selectedDocUrl && (
                <Button
                  variant="outline-success"
                  style={{
                    borderRadius: "10px",
                    padding: "6px 16px",
                    fontWeight: "bold",
                    background: "linear-gradient(to right, #6a11cb, #2575fc)",
                    color: "#fff",
                    border: "none",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                    fontSize: "1rem",
                  }}
                  onClick={handleDownload}
                >
                  <FaDownload />
                </Button>
              )}
              <Button
                variant="outline-warning"
                style={{
                  borderRadius: "10px",
                  padding: "6px 16px",
                  fontWeight: "bold",
                  background: "linear-gradient(to right, #6a11cb, #2575fc)",
                  color: "#fff",
                  border: "none",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                  fontSize: "1rem",
                }}
                onClick={() => fileInputRef.current?.click()}
              >
                <TbReplaceFilled />
              </Button>
              <input
                ref={fileInputRef}
                type="file"
                accept=".jpg,.png,.pdf"
                style={{ display: "none" }}
                onChange={handleFileReplace}
              />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          {selectedDocUrl ? (
            selectedDocUrl.endsWith(".pdf") ? (
              <iframe
                src={selectedDocUrl}
                width="100%"
                height="500px"
                style={{ border: "none" }}
                title="PDF Document Viewer"
              ></iframe>
            ) : (
              <img
                src={selectedDocUrl}
                alt="Uploaded Document"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: "8px",
                }}
                onError={(e) => {
                  e.target.src = "/fallback-image.png";
                }}
              />
            )
          ) : (
            <p style={{ color: "red", fontWeight: "bold" }}>
              No document available
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Early Leave Approval Form Modal */}
      <Modal
        show={showEarlyLeaveApprovalModal}
        onHide={() => {
          setShowEarlyLeaveApprovalModal(false);
          resetApprovalData();
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Early Leave Approval Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={printRef} className="approval-form">
            <div className="form-details">
              <p>
                <strong>Date:</strong> {approvalData.date}
              </p>
              <p>
                <strong>Employee Name:</strong> {approvalData.userName}
              </p>
              <p>
                <strong>Department:</strong> {approvalData.department}
              </p>
              <p>
                <strong>Early Leave Minutes:</strong> {approvalData.minutes}
              </p>
              <p>
                <strong>Reason:</strong> {approvalData.reason}
              </p>
              <p>
                <strong>Single Deduction Applied:</strong>{" "}
                {approvalData.singleDeduction ? "Yes" : "No"}
              </p>
              {role === "admin" && (
                <Form.Check
                  type="checkbox"
                  label="Apply Single Deduction"
                  checked={applySingleDeduction}
                  onChange={(e) => setApplySingleDeduction(e.target.checked)}
                  style={{ margin: "10px 0" }}
                />
              )}
              <hr />
              <div className="signature-area mt-4">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ textAlign: "center", width: "45%" }}>
                    <p>
                      <strong>HR Signature</strong>
                    </p>
                    {approvalData.canEditHRSignature ? (
                      <Form.Control
                        type="text"
                        value={hrSignature}
                        onChange={(e) => setHrSignature(e.target.value)}
                        placeholder="Enter HR signature"
                        style={{ margin: "10px 0" }}
                      />
                    ) : (
                      <div
                        style={{
                          borderBottom: "1px solid #000",
                          width: "100%",
                          margin: "10px auto",
                        }}
                      >
                        {hrSignature && <p style={{ fontStyle: "italic" }}>{hrSignature}</p>}
                      </div>
                    )}
                  </div>
                  <div style={{ textAlign: "center", width: "45%" }}>
                    <p>
                      <strong>Admin Signature</strong>
                    </p>
                    {approvalData.canEditAdminSignature ? (
                      <Form.Control
                        type="text"
                        value={adminSignature}
                        onChange={(e) => setAdminSignature(e.target.value)}
                        placeholder="Enter Admin signature"
                        style={{ margin: "10px 0" }}
                      />
                    ) : (
                      <div
                        style={{
                          borderBottom: "1px solid #000",
                          width: "100%",
                          margin: "10px auto",
                        }}
                      >
                        {adminSignature && <p style={{ fontStyle: "italic" }}>{adminSignature}</p>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {approvalData.canEditHRSignature && (
            <Button
              variant="success"
              onClick={() => handleApprove("earlyClose")}
            >
              Semi-Approve
            </Button>
          )}
          {approvalData.canEditAdminSignature && !approvalData.adminHasApproved && (
            <Button
              variant="success"
              onClick={() => handleApprove("earlyClose")}
            >
              Approve
            </Button>
          )}
          {role === "admin" && approvalData.adminHasApproved && (
            <Button
              variant="primary"
              onClick={() => handleApprove("earlyClose")}
            >
              Update Deduction
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => {
              setShowEarlyLeaveApprovalModal(false);
              resetApprovalData();
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={handlePrint}>
            <FaPrint /> Print
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Late Arrival Approval Form Modal */}
      <Modal
        show={showLateApprovalModal}
        onHide={() => {
          setShowLateApprovalModal(false);
          resetApprovalData();
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Late Approval Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={printRef} className="approval-form">
            <div className="form-details">
              <p>
                <strong>Date:</strong> {approvalData.date}
              </p>
              <p>
                <strong>Employee Name:</strong> {approvalData.userName}
              </p>
              <p>
                <strong>Department:</strong> {approvalData.department}
              </p>
              <p>
                <strong>Late Minutes:</strong> {approvalData.minutes}
              </p>
              <p>
                <strong>Reason:</strong> {approvalData.reason}
              </p>
              <p>
                <strong>Single Deduction Applied:</strong>{" "}
                {approvalData.singleDeduction ? "Yes" : "No"}
              </p>
              {role === "admin" && (
                <Form.Check
                  type="checkbox"
                  label="Apply Single Deduction"
                  checked={applySingleDeduction}
                  onChange={(e) => setApplySingleDeduction(e.target.checked)}
                  style={{ margin: "10px 0" }}
                />
              )}
              <hr />
              <div className="signature-area mt-4">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ textAlign: "center", width: "45%" }}>
                    <p>
                      <strong>HR Signature</strong>
                    </p>
                    {approvalData.canEditHRSignature ? (
                      <Form.Control
                        type="text"
                        value={hrSignature}
                        onChange={(e) => setHrSignature(e.target.value)}
                        placeholder="Enter HR signature"
                        style={{ margin: "10px 0" }}
                      />
                    ) : (
                      <div
                        style={{
                          borderBottom: "1px solid #000",
                          width: "100%",
                          margin: "10px auto",
                        }}
                      >
                        {hrSignature && <p style={{ fontStyle: "italic" }}>{hrSignature}</p>}
                      </div>
                    )}
                  </div>
                  <div style={{ textAlign: "center", width: "45%" }}>
                    <p>
                      <strong>Admin Signature</strong>
                    </p>
                    {approvalData.canEditAdminSignature ? (
                      <Form.Control
                        type="text"
                        value={adminSignature}
                        onChange={(e) => setAdminSignature(e.target.value)}
                        placeholder="Enter Admin signature"
                        style={{ margin: "10px 0" }}
                      />
                    ) : (
                      <div
                        style={{
                          borderBottom: "1px solid #000",
                          width: "100%",
                          margin: "10px auto",
                        }}
                      >
                        {adminSignature && <p style={{ fontStyle: "italic" }}>{adminSignature}</p>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {approvalData.canEditHRSignature && (
            <Button
              variant="success"
              onClick={() => handleApprove("late")}
            >
              Semi-Approve
            </Button>
          )}
          {approvalData.canEditAdminSignature && !approvalData.adminHasApproved && (
            <Button
              variant="success"
              onClick={() => handleApprove("late")}
            >
              Approve
            </Button>
          )}
          {role === "admin" && approvalData.adminHasApproved && (
            <Button
              variant="primary"
              onClick={() => handleApprove("late")}
            >
              Update Deduction
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => {
              setShowLateApprovalModal(false);
              resetApprovalData();
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={handlePrint}>
            <FaPrint /> Print
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Overtime Approval Form Modal */}
      <Modal
        show={showOvertimeApprovalModal}
        onHide={() => {
          setShowOvertimeApprovalModal(false);
          resetApprovalData();
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Overtime Approval Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={printRef} className="approval-form">
            <div className="form-details">
              <p>
                <strong>Date:</strong> {approvalData.date}
              </p>
              <p>
                <strong>Employee Name:</strong> {approvalData.userName}
              </p>
              <p>
                <strong>Department:</strong> {approvalData.department}
              </p>
              <p>
                <strong>Overtime Minutes:</strong> {approvalData.minutes}
              </p>
              <p>
                <strong>Reason:</strong> {approvalData.reason}
              </p>
              <hr />
              <div className="signature-area mt-4">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ textAlign: "center", width: "45%" }}>
                    <p>
                      <strong>HR Signature</strong>
                    </p>
                    {approvalData.canEditHRSignature ? (
                      <Form.Control
                        type="text"
                        value={hrSignature}
                        onChange={(e) => setHrSignature(e.target.value)}
                        placeholder="Enter HR signature"
                        style={{ margin: "10px 0" }}
                      />
                    ) : (
                      <div
                        style={{
                          borderBottom: "1px solid #000",
                          width: "100%",
                          margin: "10px auto",
                        }}
                      >
                        {hrSignature && <p style={{ fontStyle: "italic" }}>{hrSignature}</p>}
                      </div>
                    )}
                  </div>
                  <div style={{ textAlign: "center", width: "45%" }}>
                    <p>
                      <strong>Admin Signature</strong>
                    </p>
                    {approvalData.canEditAdminSignature ? (
                      <Form.Control
                        type="text"
                        value={adminSignature}
                        onChange={(e) => setAdminSignature(e.target.value)}
                        placeholder="Enter Admin signature"
                        style={{ margin: "10px 0" }}
                      />
                    ) : (
                      <div
                        style={{
                          borderBottom: "1px solid #000",
                          width: "100%",
                          margin: "10px auto",
                        }}
                      >
                        {adminSignature && <p style={{ fontStyle: "italic" }}>{adminSignature}</p>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {approvalData.canEditHRSignature && (
            <Button
              variant="success"
              onClick={() => handleApprove("overtime")}
            >
              Semi-Approve
            </Button>
          )}
          {approvalData.canEditAdminSignature && (
            <Button
              variant="success"
              onClick={() => handleApprove("overtime")}
            >
              Approve
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => {
              setShowOvertimeApprovalModal(false);
              resetApprovalData();
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={handlePrint}>
            <FaPrint /> Print
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the attendance record for{" "}
          {recordToDelete && moment(recordToDelete.date).format("YYYY-MM-DD")}🤔?
          <br />
          <strong>This action cannot be undone.</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteRecord}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </EditAtdLayout>
  );
}